import {inject, LOCALE_ID, NgModule, provideAppInitializer} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {CoreModule} from "../../../../features/core/core.module";
import {OAuthModule, OAuthService, OAuthStorage} from "angular-oauth2-oidc";
import {coreInterceptorProviders} from "../../../../features/core/shared/core.interceptor.providers";
import {AuthModule} from "../../../../features/auth/auth.module";
import {authInitializerFn} from "../../../../features/auth/auth/auth-initializer.factory";
import {TenantService} from "../../../../features/auth/tenant/tenant.service";
import {AppBreadcrumbComponent} from "./app.breadcrumb.component";
import {AppInlineMenuComponent} from "./app.inlinemenu.component";
import {AppRightMenuComponent} from "./app.rightmenu.component";
import {AppTopBarComponent} from "./app.topbar.component";
import {AppFooterComponent} from "./app.footer.component";
import {AppMainComponent} from "./app.main.component";
import {AppConfigComponent} from "./app.config.component";
import {AppMenuComponent} from "./app.menu.component";
import {AppMenuitemComponent} from "./app.menuitem.component";
import {MenuService} from "../../../../features/core/shared/service/menu/menu.service";
import {AppBreadcrumbService} from "../../../../features/core/shared/service/breadcrumb/app-breadcrumb.service";
import {ConfirmationService, MessageService} from "primeng/api";
import {
    MvsConfirmationService
} from "../../../../features/core/shared/service/confirmation/mvs-confirmation.service";
import {HashLocationStrategy, LocationStrategy, registerLocaleData} from "@angular/common";
import {
    AlphaObjectNavigationService
} from "../../../../features/core/shared/navigation/alpha-object-navigation.service";
import {MvsObjectNavigationService} from "../../../../features/core/shared/navigation/mvs-object-navigation.service";
import {FeatureCrmModule} from "../../../../features/feature-crm/feature-crm.module";
import {FeatureCoreModule} from "../../../../features/feature-core/feature-core.module";
import {FeaturePowerModule} from "../../../../features/feature-power/feature-power.module";
import {ShellAlphaModule} from "./shell-alpha.module";
import {AuthConfiguration} from "../../../../features/auth/auth-configuration";
import {environment} from "../environments/environment";
import {AuthConfigService} from "../../../../features/auth/auth/auth-config.service";
import {CoreConfig} from "../../../../features/core/service/core-config";
import {providePrimeNG} from "primeng/config";
import {MvsConfigService} from "../../../../features/core/shared/config/mvs-config.service";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {KlausPreset} from "../../../../features/core/shared/theme/Klaus-preset";
import localeDe from '@angular/common/locales/de';
import {FeatureIntegrationModule} from "../../../../features/feature-integration/feature-integration.module";
import {AppNavigationItemComponent} from "./app-navigation.component";
import {FeatureTechModule} from "../../../../features/feature-tech/feature-tech.module";
import {FeatureAuthModule} from "../../../../features/feature-auth/feature-auth.module";
import {FeatureMiscModule} from "../../../../features/feature-misc/feature-misc.module";
import {FeatureProvModule} from "../../../../features/feature-prov/feature-prov.module";
import {AuthTokenRefreshService} from "../../../../features/core/shared/auth/auth-token-refresh.service";
import {ALPHA_PROVIDERS} from "./providers/alpha.providers";
import {FeatureBmModule} from "../../../../features/feature-bm/feature-bm.module";
import {APP_LAYOUT} from "../../../../features/core/shared/layout/app-layout.token";
import {FeaturePlanningModule} from "../../../../features/feature-planning/feature-planning.module";
import {FeatureLaunchpadModule} from "../../../../features/feature-launchpad/feature-launchpad.module";

registerLocaleData(localeDe);

const authConfig: AuthConfiguration = {
    gateway: environment.gateway,
    API_URL: environment.API_URL,
    oauth2_issuer: environment.oauth2_issuer,
    tenant_alias: environment.tenant_alias,
    e2e: (environment as any).e2e || false,
    e2e_access_token: (environment as any).e2e_access_token,

    // Logo fallbacks for tenants the gateway does not serve branding for (e2e bypass, local shells).
    tenant_logoColorBright: (environment as any).tenant_logoColorBright,
    tenant_logoColorDark: (environment as any).tenant_logoColorDark,
    tenant_logoBright: (environment as any).tenant_logoBright,
    tenant_logoDark: (environment as any).tenant_logoDark
};

const coreConfig: CoreConfig = {
    API_URL: environment.API_URL,
    MS_graph_endpoint: environment.MS_graph_endpoint,
}


@NgModule({
    declarations: [
        AppComponent,
        AppBreadcrumbComponent,
        AppInlineMenuComponent,
        AppRightMenuComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppMainComponent,
        AppConfigComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppNavigationItemComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        AuthModule.forRoot(authConfig),
        OAuthModule.forRoot(),
        CoreModule.forRoot(coreConfig),
        ShellAlphaModule,
        FeatureCoreModule,
        FeatureCrmModule,
        FeaturePowerModule,
        FeatureIntegrationModule,
        FeatureTechModule,
        FeatureAuthModule,
        FeatureMiscModule,
        FeatureProvModule,
        FeatureBmModule,
        FeaturePlanningModule,
        FeatureLaunchpadModule
    ],
    providers: [
        provideAnimationsAsync(),

        AuthTokenRefreshService,
        {provide: OAuthStorage, useValue: localStorage},
        provideAppInitializer(() => {
            const initializerFn = (authInitializerFn)(inject(OAuthService), inject(TenantService), inject(AuthConfigService));
            return initializerFn();
        }),
        providePrimeNG({
            theme: {
                preset: KlausPreset,
                options: {
                    darkModeSelector: false,

                }
            },
            ripple: true,
            translation: MvsConfigService.germanConfig
        }),
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        {provide: MvsObjectNavigationService, useClass: AlphaObjectNavigationService},
        coreInterceptorProviders,
        MenuService,
        AppBreadcrumbService,
        MessageService,
        {provide: ConfirmationService, useClass: MvsConfirmationService},
        {provide: LOCALE_ID, useValue: 'de-DE'},
        ...ALPHA_PROVIDERS,
        {provide: APP_LAYOUT, useExisting: AppComponent}
    ],
    exports: [
        AppRightMenuComponent,
        AppNavigationItemComponent
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {



}